import React from "react";

import { Toolbox as Value } from "@reactivated";

import { ReusableContentBlock } from "../ReusableContent";
import { StrictBlockMap, TrackedStreamField } from "./TrackedStreamField";
import { toolboxBaseComponents } from "./toolboxBase";

export const toolboxComponents: StrictBlockMap<Value> = {
    ...toolboxBaseComponents,
    reusable_content: ReusableContentBlock,
};

export const Toolbox = (props: { value: Value }) => {
    return (
        <TrackedStreamField
            tagName={React.Fragment}
            components={toolboxComponents}
            value={props.value}
        />
    );
};
